const SCHEMES = {
  classic: {
    bgColor: 'black',
    snakeHeadColor: 'lime',
    snakeBodyColor: 'green',
    appleColor: 'red'
  },
  blend: {
    bgColor: '#532F8C',
    snakeHeadColor: 'white',
    snakeBodyColor: 'grey',
    appleColor: 'cyan'
  },
};

export default SCHEMES;
